/**
 * Layout commun pour les pages publiques d'authentification secondaires
 * (reset request, reset confirm, accept invite).
 *
 * Refonte 9.P.1 — mono-colonne sobre, alignée avec LoginPage 9.O.1 mais
 * sans split-panel hero (Q5.1 PO = B). Les flows secondaires sont purement
 * transactionnels (1-2 inputs) — un panneau navy-950 hero serait
 * disproportionné. KollectiviaWordmark canonique en header pour la signature
 * brand, sur fond slate-50.
 *
 * a11y :
 *   - <main id="main"> + tabIndex={-1} pour focus programmatique.
 *   - h1 sémantique direct, pas dans un wrapper visuel non-sémantique.
 *   - min-h-dvh (mobile viewport unit fix) + safe-area-inset-bottom.
 */

import { type ReactNode } from "react";

import { LanguageSwitcher } from "../../components/LanguageSwitcher";
import { KollectiviaWordmark } from "../../components/brand/KollectiviaMark";

export function AuthCardLayout({
  children,
  title,
  subtitle,
}: {
  children: ReactNode;
  title: string;
  subtitle?: string;
}) {
  return (
    <div className="flex min-h-dvh flex-col bg-slate-50 pb-[env(safe-area-inset-bottom)]">
      <main
        id="main"
        role="main"
        tabIndex={-1}
        className="flex w-full flex-1 flex-col items-center justify-center px-6 py-12 focus:outline-none"
      >
        <div className="w-full max-w-sm">
          <div className="mb-8 flex items-center justify-between">
            <KollectiviaWordmark markSize={24} textSize={16} />
            <LanguageSwitcher />
          </div>

          <h1 className="text-pretty text-2xl font-semibold tracking-tight text-slate-900">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-1 text-sm text-slate-600">{subtitle}</p>
          )}

          <div className="mt-6">{children}</div>
        </div>
      </main>
    </div>
  );
}
